import { useState } from "react";
import axios from "axios";

const useGetCast = (url) => {
  const [casting, setCasting] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  async function getCast() {
    try {
      const response = await axios.get(url);
      const limit = 10;
      const result = response.data.cast.slice(0, limit);
      setCasting(result);
      setLoading(false);
      setError(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  }

  return { casting, loading, error, getCast };
};

export default useGetCast;
